const calculateSignaturePosition = (
  droppedX: number,
  itemWidth: number,
  boundingBox: { width: number },
  offsetInitialSource: { x: number },
  offsetInitialClientOffset: { x: number }
) => {
  const offsetInitialSourceRight = offsetInitialSource.x + itemWidth;
  const offsetInitialSourceDifference = offsetInitialSourceRight - offsetInitialClientOffset.x;
  const isSignaturePlacedOnEdge = droppedX + offsetInitialSourceDifference > boundingBox.width;
  const rawX = isSignaturePlacedOnEdge ? boundingBox.width - itemWidth : droppedX - (itemWidth - offsetInitialSourceDifference);

  return {
    x: Math.max(0, rawX),
  };
};

export default calculateSignaturePosition;
